import { api } from '@lib/orpc-client'
import { TonWalletUtils } from '@lib/secrets'

type CreateUnsignedMigrationResponse = Awaited<
  ReturnType<typeof api.wallet.migrations.createUnsignedJs>
>
export type UnsignedTransactionResponse = Extract<
  CreateUnsignedMigrationResponse,
  {
    serializedTransaction: string
    seqNo: number
  }
>

function hasUnsignedTransaction(
  response: CreateUnsignedMigrationResponse
): response is UnsignedTransactionResponse {
  return (
    'serializedTransaction' in response &&
    typeof response.serializedTransaction === 'string' &&
    'seqNo' in response &&
    typeof response.seqNo === 'number'
  )
}

export async function requestUnsignedMigrationTransaction() {
  try {
    const response = await api.wallet.migrations.createUnsignedJs({})
    if (!hasUnsignedTransaction(response)) {
      throw new Error(`Migration is not ready for signing: ${response.status}`)
    }
    return response
  } catch (error) {
    throw error
  }
}

export async function sendSignedMigrationTransaction(trx: string) {
  try {
    return await api.wallet.migrations.returnJsMintSc({
      signedTransactionBOC: trx
    })
  } catch (error) {
    throw error
  }
}

export async function migrate() {
  try {
    const { serializedTransaction, seqNo } = await requestUnsignedMigrationTransaction()
    const signedTrx = await TonWalletUtils.signMessage(serializedTransaction, seqNo)
    await sendSignedMigrationTransaction(signedTrx)
  } catch (error) {
    throw error
  }
}
